import React from "react"
import Graph from "src/graph/graph"
import { gotoAST } from "./gotoAST"

/**
 * @param props {{
 *  scState: scState
 * }}
 */
export default function AnalyzerArchitecture({ scState }) {
  const onResourceClick = (resource) => {
    scState.set_selectedFile(resource.declaredInFile)
    scState.set_selectedResource(resource)

    if (resource.astId) {
      setTimeout(() => {
        gotoAST(resource.astId)
      })
    }
  }

  return (
    <div css="min-height:100%;padding:22px 20px;background-color:#f6f6fa;">
      <div
        css={`
          width: 100%;
          cursor: pointer;
          color: #799fd4;
          text-decoration: underline;
          padding-right: 12px;
          position: absolute;
          align-self: flex-start;
          top: 0;
          z-index: 999;
          padding-top: 20px;
        `}
        onClick={() => {
          scState.set_selectedResourseType('Modifiers')
          scState.toogleArchitectureRoute(false)}}
      >
        ← Back to resource inspector
      </div>
      <div
        css={`
          position: relative;
        `}
      >
        <Graph scState={scState} onResourceClick={onResourceClick} />
      </div>
    </div>
  )
}
